import React from 'react';
import { B } from '../constants';

const PLATFORM_META = {
  insta_reel: { label: 'Instagram Reels', icon: '📱', color: '#E4405F' },
  fb_reel: { label: 'Facebook Reels', icon: '📘', color: '#1877F2' },
  twitter: { label: 'Twitter/X', icon: '🐦', color: '#1DA1F2' },
  yt_shorts: { label: 'YouTube Shorts', icon: '▶️', color: '#FF0000' },
};

function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

export default function PlatformStatsCard({ platform, stats, isBest }) {
  const meta = PLATFORM_META[platform] || { label: platform, icon: '📊', color: B.muted };

  return (
    <div style={{
      padding: 16, borderRadius: 14,
      background: isBest ? 'rgba(26,107,74,0.06)' : 'white',
      border: `1px solid ${isBest ? B.forest : B.sand}`,
      position: 'relative', overflow: 'hidden',
    }}>
      {isBest && (
        <div style={{ position: 'absolute', top: 0, right: 0, background: B.forest, color: 'white', fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: '0 14px 0 10px', letterSpacing: 0.5 }}>
          BEST
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: meta.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
          {meta.icon}
        </div>
        <span style={{ fontWeight: 700, fontSize: 14, fontFamily: "'Montserrat',sans-serif" }}>{meta.label}</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontFamily: "'Montserrat',sans-serif", fontSize: 12 }}>
        <div>
          <div style={{ color: B.muted, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>Shares</div>
          <div style={{ fontWeight: 700, fontSize: 18 }}>{stats.sharesCount}</div>
        </div>
        <div>
          <div style={{ color: B.muted, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>Clicks</div>
          <div style={{ fontWeight: 700, fontSize: 18 }}>{stats.clickThroughs}</div>
        </div>
        <div>
          <div style={{ color: B.muted, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>CTR</div>
          <div style={{ fontWeight: 700, fontSize: 16, color: stats.ctr > 5 ? B.forest : B.muted }}>{stats.ctr}%</div>
        </div>
        <div>
          <div style={{ color: B.muted, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>Bookings</div>
          <div style={{ fontWeight: 700, fontSize: 16 }}>{stats.bookingsCount}</div>
        </div>
        {stats.bookingsCount > 0 && (
          <div style={{ gridColumn: '1 / -1' }}>
            <div style={{ color: B.muted, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>Revenue</div>
            <div style={{ fontWeight: 700, fontSize: 18, color: B.forest }}>{formatMoney(Math.round(stats.bookingRevenue * 100))}</div>
          </div>
        )}
      </div>
      <div style={{ marginTop: 10, paddingTop: 8, borderTop: `1px solid ${B.sand}`, fontSize: 10, color: B.muted }}>
        Conversion: {stats.conversionRate}% · Last shared: {stats.lastSharedAt ? new Date(stats.lastSharedAt).toLocaleDateString() : 'Never'}
      </div>
    </div>
  );
}
